<template>
  <div class="commercialBreakWrapper" :class="{ visible: canShowCommercialBreak }">
    <div class="commercialBreakHeader">
      <div class="timer">Reklama zostanie<br>zamknięta za {{ redirectTime }} sek.</div>
      <button @click.prevent="close">Idź do serwisu</button>
    </div>
    <div class="commercialBreak" v-if="isContentTypeImage">
      <a v-if="commercialBreake.targetUrl" :href="commercialBreake.targetUrl" aria-label="Przejście na stronę reklamy"
         target="_blank">
        <img class="commercialBreakeImg" :src="commercialBreake.imgSrc" :title="commercialBreake.title"
             :alt="commercialBreake.alt">
      </a>
      <div v-if="!commercialBreake.targetUrl">
        <img class="commercialBreakeImg" :src="commercialBreake.imgSrc" :title="commercialBreake.title"
             :alt="commercialBreake.alt">
      </div>
    </div>
    <div class="commercialBreak" v-if="isContentTypeVideo" v-html="commercialBreake.videoContainer"></div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import Vue from 'vue'
import { COMMERCIAL_BREAK_REDIRECT_TIME } from '@/base/const/confirmation.const'
import { ToolsClass } from '@/base/class/tools.class'
import { ADS_BANNER_SIZE } from '@/base/const/ads.const'

export default {
  name: 'CommercialBreak',
  data () {
    return {
      redirectHandler: null,
      redirectTime: Vue.prototype.$VUE_COMMERCIAL_BREAK_REDIRECT_TIME ? Vue.prototype.$VUE_COMMERCIAL_BREAK_REDIRECT_TIME : COMMERCIAL_BREAK_REDIRECT_TIME,
      confirmed: null
    }
  },
  computed: {
    ...mapState({
      showCommercialBreake: state => state.ads.showCommercialBreake
    }),
    ...mapGetters({
      commercialBreake: 'getCommercialBreak'
    }),
    canShowCommercialBreak: function () {
      return !!this.commercialBreake && this.showCommercialBreake
    },
    isContentTypeImage: function () {
      return this.commercialBreake && this.commercialBreake.contentType === 'image'
    },
    isContentTypeVideo: function () {
      return this.commercialBreake && this.commercialBreake.contentType === 'video'
    }
  },
  watch: {
    commercialBreake: function (val, oldVal) {
      if (val && val !== oldVal && this.isContentTypeVideo) {
        ToolsClass.parseAndLoadExternalScriptToHeader(this.commercialBreake.scriptEmbed, () => {
          console.log('commercial break external script loaded')
          setTimeout(() => {
            const rootDiv = document.querySelector('div.commercialBreak')
            if (rootDiv) {
              this.setHeightRecursive(rootDiv)
            }
          }, 1000)
        })
      }
    },
    canShowCommercialBreak: function (val) {
      if (val && !this.redirectHandler) {
        if (this.isContentTypeImage) {
          this.startRedirectTimeout()
          this.sendViewConfirmation()
        }
        if (this.isContentTypeVideo) {
          this.startRedirectTimeout()
          this.sendViewConfirmation()
        }
      }
    }
  },
  methods: {
    ...mapMutations([
      'SET_ADS_COMMERCIAL_BREAK_CLOSED',
      'SET_ADS_SIZE'
    ]),
    ...mapActions([
      'sendAdsBannerViewConfirmation'
    ]),
    sendViewConfirmation () {
      if (!!this.confirmed && this.confirmed === this.commercialBreake.creationId) {
        return
      }
      const data = {
        creationId: this.commercialBreake.creationId
      }
      this.sendAdsBannerViewConfirmation(data)
        .catch(() => {
        })
        .finally(() => {
          this.confirmed = this.commercialBreake.creationId
        })
    },
    setWindowSize () {
      if (ToolsClass.isMobileScreenSize()) {
        this.SET_ADS_SIZE(ADS_BANNER_SIZE.mobile)
        return
      }
      this.SET_ADS_SIZE(ADS_BANNER_SIZE.desktop)
    },
    close () {
      this.stopRedirectTimeout()
      this.SET_ADS_COMMERCIAL_BREAK_CLOSED(true)
    },
    stopRedirectTimeout () {
      if (this.redirectHandler) {
        clearTimeout(this.redirectHandler)
      }
    },
    startRedirectTimeout () {
      this.redirectHandler = setTimeout(this.checkRedirectTimeout, 1000)
    },
    checkRedirectTimeout () {
      if (this.redirectTime === 1) {
        this.close()
        return
      }
      this.redirectTime--
      this.startRedirectTimeout()
    },
    setHeightRecursive (element) {
      // Jeśli nie ma elementu, nic nie rób
      if (!element) return
      // Znajdź div bezpośrednio wewnątrz aktualnego elementu
      const child = element.querySelector(':scope > div, :scope > iframe')
      if (child) {
        // Ustaw height: 100% dla znalezionego div
        child.classList.add('fullheight')

        // Rekurencyjnie wykonaj to samo dla tego dziecka
        // Rekurencja tylko jeśli child jest div
        if (child.tagName.toLowerCase() === 'div') {
          this.setHeightRecursive(child)
        }
      }
    }
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.setWindowSize()
    })
    window.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') {
        this.close()
      }
    })
  }
}
</script>

<style lang="scss">
@use '../../assets/scss/mixins' as *;
@use '../../assets/scss/variables' as *;

.commercialBreakWrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 100;
  background: #000;
  display: none;
  flex-direction: column;
  align-items: center;

  &.visible {
    display: flex;
  }

  .fullheight {
    height: 100% !important;
  }

  .commercialBreakHeader {
    background: #fff;
    width: 100%;
    height: 70px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    gap: 20px;

    @include sm {
      justify-content: flex-end;
    }

    .timer {
      width: 120px;
      font-size: 11px;
      line-height: 14px;
      color: #000;
    }

    button {
      background-color: var(--button-bg-default);
      height: 30px;
      border-radius: 15px;
      border: none;
      padding: 5px 20px;
      font-size: 11px;
      color: #fff;
      cursor: pointer;
    }
  }

  .commercialBreak {
    width: 100%;
    height: calc(100% - 70px);
    padding: 10px;
    display: block;
    text-align: center;

    @include sm {
      width: 80%;
      padding: 40px;
    }

    &.fullscreen {
      a {
        width: 100%;
        height: 100%;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
</style>
